import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { useLiveStream } from "../../context/LiveStreamContext";
import { AppImages } from "../../utility/AppImages";
import ImageComponent from "../ImageComponent";
import Avatar from "../choose-avatar-components/Avatar";
import { LinearGradient } from "expo-linear-gradient";

const Voting = ({ pollEndTime }) => {
  const [votingData, setVotingData] = useState({
    totalVotes: 0,
    organiserPercent: 0,
    challengerPercent: 0,
  });

  const deviceSize = useDeviceSize();
  const [countdown, setCountdown] = useState("");
  const { audienceData } = useLiveStream();

  const { eventDetails, participantDetails } = audienceData;

  const organizer =
    participantDetails.find(
      (participant) => participant?.userID === eventDetails.organiserId
    ) || {};

  const challenger =
    participantDetails.find(
      (participant) => participant.userID !== eventDetails.organiserId
    ) || {};

  const isMobile =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS;

  useEffect(() => {
    if (!pollEndTime) return;

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const endTime = new Date(pollEndTime).getTime() + 5 * 60 * 1000;
      const timeLeft = endTime - now;
      if (timeLeft <= 0) {
        clearInterval(interval);
        setCountdown("00:00");
      } else {
        const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        const seconds = Math.floor((timeLeft / 1000) % 60);
        setCountdown(
          `${minutes < 10 ? `0${minutes}` : minutes}:${
            seconds < 10 ? `0${seconds}` : seconds
          }`
        );
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [pollEndTime]);

  useEffect(() => {
    if (!audienceData.eventDetails.publicVoteStats) {
      return;
    }
    setVotingData(audienceData.eventDetails.publicVoteStats);
  }, [audienceData.eventDetails.publicVoteStats]);

  return (
    <View
      style={{
        flexDirection: "column",
        gap: isMobile ? 12 : 16,
      }}
    >
      {/* Voting Message - Above player sections */}
      <View
        style={{
          alignItems: "center",
          gap: 16,
          paddingHorizontal: isMobile ? 16 : 0,
        }}
      >
        {/* "Thanks for voting!" Text */}
        <Text
          style={{
            color: "#00FF26",
            fontFamily: "Anybody_700Bold",
            fontSize: isMobile ? 20 : 32,
            fontWeight: "700",
            textAlign: "center",
          }}
        >
          Thanks for voting!
        </Text>

        {/* Red Message Box */}
        <LinearGradient
          colors={["rgba(127, 29, 29, 0.20)", "rgba(153, 27, 27, 0.20)"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={{
            width: isMobile ? "100%" : 539,
            padding: 16,
            flexDirection: "column",
            alignItems: "center",
            gap: 12,
            borderRadius: 8,
            borderWidth: 0.8,
            borderColor: "rgba(239, 68, 68, 0.30)",
          }}
        >
          <Text
            style={{
              color: "#DC2626",
              textAlign: "center",
              fontFamily: "Anybody_900Black",
              fontSize: isMobile ? 18 : 26,
              fontWeight: "900",
              lineHeight: isMobile ? 20.79 : 30.03,
            }}
          >
            Current standings
          </Text>
        </LinearGradient>

        {/* Countdown Timer */}
        <Text
          style={{
            color: AppColors.white,
            fontFamily: "Anybody_600SemiBold",
            fontSize: isMobile ? 14 : 18,
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Result announce time:{" "}
          <Text
            style={{
              fontFamily: "Anybody_800ExtraBold",
              fontSize: isMobile ? 18 : 24,
              fontWeight: "800",
            }}
          >
            {countdown}
          </Text>
        </Text>
      </View>

      {/* Player Sections Row */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingHorizontal: isMobile ? 0 : 16,
          paddingVertical: 0,
          gap: isMobile ? 8 : 16,
        }}
      >
        {/* Organizer Section */}
        <View
          style={{
            flex: 1,
            alignItems: "center",
            gap: isMobile ? 4 : 6,
            height: isMobile ? 140 : 170,
          }}
        >
          {/* Kaller Label */}
          <Text
            style={[
              isMobile
                ? AppFontStyle.BOLD_ANYBODY_14
                : AppFontStyle.BOLD_ANYBODY_18,
              {
                marginBottom: 10,
                color: "#DC2626",
              },
            ]}
          >
            Kaller
          </Text>

          <View
            style={{
              display: "flex",
              height: isMobile ? undefined : 160,
              padding: isMobile ? 2 : 12,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: isMobile ? 4 : 8,
              width: isMobile ? 120 : 160,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: "#374151",
              backgroundColor: "rgba(31, 41, 55, 0.50)",
            }}
          >
            <View
              style={{
                width: isMobile ? 60 : 80,
                height: isMobile ? 60 : 80,
                overflow: "hidden",
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                variant={isMobile ? "player" : "profileMedium"}
                src={
                  organizer.profilePicture === ""
                    ? "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                    : organizer.profilePicture
                }
              />
            </View>
            <Text
              style={[
                isMobile
                  ? AppFontStyle.BOLD_ANYBODY_14
                  : AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white, textAlign: "center" },
              ]}
              numberOfLines={1}
            >
              {organizer.userID || "Unknown"}
            </Text>
            {/* Percentage */}
            <Text
              style={{
                color: "#00FF26",
                fontFamily: "Anybody_800ExtraBold",
                fontSize: isMobile ? 18 : 22,
                fontWeight: "800",
                textAlign: "center",
              }}
            >
              {votingData?.organiserPercent || 0}%
            </Text>
          </View>
        </View>

        {/* Game Section */}
        <View
          style={{
            alignItems: "center",
            flex: isMobile ? 0.5 : 0.6,
            justifyContent: "center",
            gap: isMobile ? 6 : 16,
            height: isMobile ? 150 : 170,
          }}
        >
          {/* VS Logo */}
          <ImageComponent
            url={AppImages.icVsLogo}
            style={{
              width: isMobile ? 40 : 56,
              height: isMobile ? 80 : 126.274,
              resizeMode: "contain",
            }}
          />
        </View>

        {/* Challenger Section */}
        <View
          style={{
            flex: 1,
            alignItems: "center",
            gap: isMobile ? 4 : 6,
            height: isMobile ? 150 : 170,
          }}
        >
          {/* Opponent Label */}
          <Text
            style={[
              isMobile
                ? AppFontStyle.BOLD_ANYBODY_14
                : AppFontStyle.BOLD_ANYBODY_18,
              {
                marginBottom: 10,
                color: "#DC2626",
              },
            ]}
          >
            Opponent
          </Text>

          <View
            style={{
              display: "flex",
              height: isMobile ? undefined : 160,
              padding: isMobile ? 2 : 12,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: isMobile ? 4 : 8,
              width: isMobile ? 120 : 160,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: "#374151",
              backgroundColor: "rgba(31, 41, 55, 0.50)",
            }}
          >
            <View
              style={{
                width: isMobile ? 60 : 80,
                height: isMobile ? 60 : 80,
                overflow: "hidden",
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                variant={isMobile ? "player" : "profileMedium"}
                src={
                  challenger.profilePicture === ""
                    ? "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                    : challenger.profilePicture
                }
              />
            </View>
            <Text
              style={[
                isMobile
                  ? AppFontStyle.BOLD_ANYBODY_14
                  : AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white, textAlign: "center" },
              ]}
              numberOfLines={1}
            >
              {challenger.userID || "Unknown"}
            </Text>
            {/* Percentage */}
            <Text
              style={{
                color: "#00FF26",
                fontFamily: "Anybody_800ExtraBold",
                fontSize: isMobile ? 18 : 22,
                fontWeight: "800",
                textAlign: "center",
              }}
            >
              {votingData?.challengerPercent || 0}%
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default Voting;
